const apiBirthDatePattern = /^(\d{2})-(\d{2})-(\d{4})$/
const displayBirthDatePattern = /^(\d{2})\.(\d{2})\.(\d{4})$/

export const formatBirthDateForDisplay = (birthDate?: string | null): string | undefined =>
  birthDate?.replace(apiBirthDatePattern, '$1.$2.$3')

export const formatBirthDateForApi = (birthDate: string): string =>
  birthDate.replace(displayBirthDatePattern, '$1-$2-$3')
